<template>
	<div class="article">
		<a :href="href" class="article-inner">
			<span class="article-header">{{ header }}</span>
			<span class="article-content">{{ content }}</span>
		</a>
	</div>
</template>

<script>
import { API_URL } from '../../../config/config';
export default {
	name: "ArticleCard",
	props: ["article"],
	computed: {
		href: function () {
			return `${API_URL}/console/doc/v1/article-view?id=${this.article.id}`;
		},
		header: function () {
			return this.article.title;
		},
		content: function () {
			return this.article.description;
		},
	},
};
</script>